import React from "react";
import styles from "./LoaderCircle.module.scss";

export const LoaderCircle = ({
  position,
}: {
  position?: "relative" | "absolute";
}) => {
  return (
    <div
      className={styles["loader"]}
      data-position={position === "relative" ? "relative" : "absolute"}
    ></div>
  );
};
